export default {
  methods: {
    i18n(key) {
      return window.i18n(key);
    },
  }
}
